import { io } from "socket.io-client";

const socketBase =
  (process.env.REACT_APP_SOCKET_URL || "").trim() ||
  (process.env.REACT_APP_API_URL || "").trim().replace(/\/api\/?$/, "") ||
  undefined;

export const socket = io(socketBase, {
  transports: ["websocket"],
});
